import { IAutocomplete, IFieldType, IFormSchema, IStatus } from "shared/types";
import { copy } from "shared/assets";

const { errors, form } = copy;

export const makeSchema = (confirmValue: string, handleClose: () => void): IFormSchema => ({
  fields: [
    {
      name: "confirm",
      label: form.confirmDelete,
      type: IFieldType.text,
      autocomplete: IAutocomplete.off,
      validation: {
        required: errors.required,
        validate: {
          value: (value: string) => confirmValue === value || errors.notValid,
        },
      },
    },
  ],
  buttons: {
    primary: {
      children: copy.form.delete,
      status: IStatus.error,
      "data-testid": "band_delete_confirm",
    },
    secondary: {
      children: copy.form.keep,
      onClick: handleClose,
      "data-testid": "band_delete_cancel",
    },
  },
});
